import fp from "lodash/fp";
import { reducer } from "redux-form";

import { APP_EDIT_FORM_NAME_FEES } from "globalConstants";
import { findFieldFromTemplate } from "models";

import { reduxFormConstants } from "./reduxForm.constants";

export const form = reducer.plugin({
	// Could be more DRY
	feesEditForm: (state, action) => {
		switch (action.type) {
			case reduxFormConstants[APP_EDIT_FORM_NAME_FEES].UNLOCK_FIELD:
				const template = fp.cloneDeep(state.values[action.template]);
				const field = findFieldFromTemplate(template, action);

				if (!fp.isEmpty(field)) {
					field.locked = false;
				}

				return {
					...state,
					values: {
						...state.values,
						[action.template]: template,
					},
				};
			case reduxFormConstants[APP_EDIT_FORM_NAME_FEES].MERGE_SYNC_ERRORS:
				return {
					...state,
					syncErrors: {
						...state.syncErrors,
						...action.errors,
					},
				};
			default:
				return state;
		}
	},
	feeTabsForm: (state, action) => {
		switch (action.type) {
			case reduxFormConstants["feeTabsForm"].UNLOCK_FIELD:
				const template = fp.cloneDeep(state.values[action.template]);
				const field = findFieldFromTemplate(template, action);

				if (!fp.isEmpty(field)) {
					field.locked = false;
				}

				return {
					...state,
					values: {
						...state.values,
						[action.template]: template,
					},
				};
			default:
				return state;
		}
	},
	"addUser.rolePermissions": (state, action) => {
		switch (action.type) {
			case reduxFormConstants["addUser.rolePermissions"]
				.SET_PERMISSIONS: {
				return {
					...state,
					values: {
						...state.values,
						permissions: state.values.permissions.map(
							({ isExtra, ...p }) => ({
								...p,
								isChecked: action.permissionIds.includes(p.id),
							}),
						),
					},
				};
			}
			default:
				return state;
		}
	},
	"addUser.merchantLinks": (state, action) => {
		switch (action.type) {
			case reduxFormConstants["addUser.merchantLinks"].REMOVE_MERCHANT: {
				return {
					...state,
					values: {
						...state.values,
						userMerchants: fp.remove({
							id: action.merchant.id,
						})(state.values.userMerchants),
					},
				};
			}
			default:
				return state;
		}
	},
	addAgentOfficeForm: (state, action) => {
		switch (action.type) {
			case reduxFormConstants["addAgentOfficeForm"]
				.REMOVE_RESPONSIBILITIE: {
				return {
					...state,
					values: {
						...state.values,
						keySupportResponsibilities: fp.remove({
							value: action.option.value,
						})(state.values.keySupportResponsibilities),
					},
				};
			}
			default:
				return state;
		}
	},
	editAgentOfficeForm: (state, action) => {
		switch (action.type) {
			case reduxFormConstants["editAgentOfficeForm"]
				.REMOVE_RESPONSIBILITIE: {
				return {
					...state,
					values: {
						...state.values,
						keySupportResponsibilities: fp.remove({
							value: action.option.value,
						})(state.values.keySupportResponsibilities),
					},
				};
			}
			default:
				return state;
		}
	},
	"addMerchantUser.rolePermissions": (state, action) => {
		switch (action.type) {
			case reduxFormConstants["addMerchantUser.rolePermissions"]
				.SET_PERMISSIONS: {
				return {
					...state,
					values: {
						...state.values,
						permissions: state.values.permissions.map(p => ({
							...p,
							isChecked: action.permissionIds.includes(p?.id),
						})),
					},
				};
			}
			default:
				return state;
		}
	},
	"addMerchantUser.merchantLinks": (state, action) => {
		switch (action.type) {
			case reduxFormConstants["addMerchantUser.merchantLinks"]
				.REMOVE_MERCHANT: {
				return {
					...state,
					values: {
						...state.values,
						userMerchants: fp.remove({
							id: action.merchant.id,
						})(state.values.userMerchants),
					},
				};
			}
			default:
				return state;
		}
	},
	"editUser.settings": (state, action) => {
		switch (action.type) {
			case reduxFormConstants["editUser.settings"].SET_PERMISSIONS: {
				return {
					...state,
					values: {
						...state.values,
						personalPermissions:
							state.values.personalPermissions.map(p => ({
								...p,
								isChecked: action.permissionIds.includes(p?.id),
							})),
					},
				};
			}
			default:
				return state;
		}
	},
	"editUser.links": (state, action) => {
		switch (action.type) {
			case reduxFormConstants["editUser.links"].REMOVE_MERCHANT: {
				return {
					...state,
					values: {
						...state.values,
						userMerchants: fp.remove({
							id: action.merchant.id,
						})(state.values.userMerchants),
					},
				};
			}
			default:
				return state;
		}
	},
	listOfMerchants: (state, action) => {
		switch (action.type) {
			case reduxFormConstants["listOfMerchants"].REMOVE_MERCHANT: {
				return {
					...state,
					values: {
						...state.values,
						merchantAgents: fp.remove({
							id: action.merchant.id,
						})(state.values.merchantAgents),
					},
				};
			}
			default:
				return state;
		}
	},
	agentSetupForm: (state, action) => {
		switch (action.type) {
			case reduxFormConstants["agentSetupForm"].REMOVE_RESPONSIBILITIE: {
				return {
					...state,
					values: {
						...state.values,
						keySupportResponsibilities: fp.remove({
							value: action.option.value,
						})(state.values.keySupportResponsibilities),
					},
				};
			}
			default:
				return state;
		}
	},
});
